export default {
      id: "ic_arrow_left-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_left-usage",
      toString: function () {
        return this.url;
      }
    }